import type { RefObject } from 'react';
import { useEffect } from 'react';

type Args = {
  detailsElRef: RefObject<HTMLDetailsElement | null>;
  onToggle: (open: boolean) => void;
};

export function useOnDetailsToggle({ detailsElRef, onToggle }: Args) {
  useEffect(() => {
    const detailsEl = detailsElRef.current;
    if (!detailsEl) return;

    const callback = () => {
      onToggle(detailsEl.open);
    };

    detailsEl.addEventListener('toggle', callback);

    return () => {
      detailsEl.removeEventListener('toggle', callback);
    };
  }, [detailsElRef, onToggle]);
}
